module.exports = __webpack_public_path__ + "img/speaker-l2.aae3b0c1.jpg";